import cn from '@/utils/cn'
import IconsSelectorDTP from '@/components/Molecules/IconsSelector/IconsDTP'
import IconClock from '@/components/Atoms/Icons/IconClock'
import IconDate from '@/components/Atoms/Icons/IconCalendar'
import IconDtp1 from '@/components/Atoms/Icons/IconDTPOne'
import IconDtp2 from '@/components/Atoms/Icons/IconDTPTwo'
import IconDtp3 from '@/components/Atoms/Icons/IconDtpThree'
import IconList from '@/components/Atoms/Icons/IconList'

import Box from '@mui/material/Box'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import Tooltip from '@mui/material/Tooltip'
import dayjs from 'dayjs'
import * as React from 'react'
import { FC } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import IconDtp4 from '@/components/Atoms/Icons/IconDtpFour'
import IconDtp5 from '@/components/Atoms/Icons/IconDtpFive'

const s = cn('devices-list')

type SeverityTypeId = 1 | 2 | 3

const SEVERITY_TEXT: Record<SeverityTypeId, string> = {
  1: 'Смертельное',
  2: 'С пострадавшими',
  3: 'Без пострадавших',
}

export type DtpUnit = {
  accidentDate: string
  address: string
  clusterTypeId: number
  dead: number
  id: number
  injured: number
  name: string
  severityTypeId: SeverityTypeId
  smart: boolean
  trafficAccidentType: string
  type: string
  typeId: number
}

interface Props {
  unit: DtpUnit
}

const TableViewDTP: FC<Props> = ({ unit }) => {
  const navigate = useNavigate()
  const rawDate = unit.accidentDate
  const date = dayjs(rawDate).format('DD.MM.YYYY')
  const time = dayjs(rawDate).format('HH.mm')

  return (
    <>
      <TableRow
        hover
        tabIndex={-1}
        to={`${unit.id}`}
        component={Link}
        className={s()}
        sx={{ textDecoration: 'none' }}
        // onClick={() => navigate(`${unit.id}`)}
      >
        <TableCell
          component='th'
          scope='row'
          width={'100%'}
        >
          <Box
            display='flex'
            alignItems='end'
            gap={1}
          >
            <Link
              to={`${unit.id}`}
              className={s('link')}
            >
              <span
                className={s('name')}
                style={{ color: 'gray' }}
              >
                {unit.name}
              </span>
              <span
                className={s('address')}
                style={{ color: '#0072BC' }}
              >
                {unit.address}
              </span>
            </Link>
          </Box>
        </TableCell>

        <TableCell
          align='right'
          sx={{
            color: '#0072BC',
            cursor: 'pointer',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'end',
              gap: '25px',
            }}
          >
            <Box
              display='flex'
              gap={2}
              alignItems='center'
              justifyContent='start'
            >
              <Box>
                {unit.clusterTypeId === 16 && (
                  <Tooltip
                    title={'Предочаг концентрации ДТП'}
                    placement='top'
                  >
                    <div>
                      <IconDtp4 />
                    </div>
                  </Tooltip>
                )}
                {unit.clusterTypeId === 17 && (
                  <Tooltip
                    title={'Место концентрации ДТП'}
                    placement='top'
                  >
                    <div>
                      <IconDtp5 />
                    </div>
                  </Tooltip>
                )}
                {unit.clusterTypeId === 0 && <div style={{ width: '25px' }} />}
              </Box>
              <Box
                display='flex'
                gap={1}
                alignItems='center'
                justifyContent='start'
              >
                {!unit.injured && (
                  <Tooltip
                    title={'Погибших'}
                    placement='top'
                  >
                    <Box
                      display='flex'
                      gap={1}
                      alignItems='center'
                      justifyContent='start'
                    >
                      <IconDtp1
                        width={20}
                        height={20}
                      />
                      {unit.dead}
                    </Box>
                  </Tooltip>
                )}
                {!unit.dead && (
                  <Tooltip
                    title={'Раненых'}
                    placement='top'
                  >
                    <Box
                      display='flex'
                      gap={1}
                      alignItems='center'
                      justifyContent='start'
                    >
                      <IconDtp2
                        width={20}
                        height={20}
                      />
                      {unit.injured}
                    </Box>
                  </Tooltip>
                )}
                {!!unit.dead && !!unit.injured && (
                  <Tooltip
                    title={`Погибло ${unit.dead}, Ранено ${unit.injured}`}
                    placement='top'
                  >
                    <Box
                      display='flex'
                      gap={1}
                      alignItems='center'
                      justifyContent='start'
                    >
                      <IconDtp3
                        width={20}
                        height={20}
                      />
                      {unit.dead + unit.injured}
                    </Box>
                  </Tooltip>
                )}
              </Box>
            </Box>

            <Box
              display='flex'
              gap={2}
              alignItems='center'
              justifyContent='start'
            >
              <Box
                display='flex'
                gap={1}
                alignItems='center'
              >
                <IconList
                  width={20}
                  height={20}
                />
                <Tooltip
                  title={unit.trafficAccidentType}
                  placement='top'
                >
                  <Box
                    sx={{
                      whiteSpace: 'nowrap',
                      width: '200px',
                      maxWidth: '250px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      textAlign: 'left',
                    }}
                  >
                    {unit.trafficAccidentType}
                  </Box>
                </Tooltip>
              </Box>
            </Box>

            <Box
              display='flex'
              gap={2}
              alignItems='center'
              justifyContent='end'
            >
              <Box
                display='flex'
                gap={1}
                alignItems='center'
              >
                <IconDate
                  width={20}
                  height={20}
                />
                {date}
              </Box>
              <Box
                display='flex'
                gap={1}
                alignItems='center'
                width={100}
              >
                <IconClock
                  width={20}
                  height={20}
                />
                {time}
              </Box>
            </Box>
          </Box>
        </TableCell>
      </TableRow>
    </>
  )
}

export default TableViewDTP
